export type PredictionView = 'time' | 'accuracy' | 'table'

export const PREDICTION_VIEWS: PredictionView[] = ['time', 'accuracy', 'table']
export const DEFAULT_PREDICTION_VIEW: PredictionView = 'time'
